<template>
  <EditForm :question="question"/>
</template>

<script>
import EditForm from '@/pages/admin/questions/test/EditForm'
import TestQuestionService from '@/services/TestQuestionService'

export default {
  components: {EditForm},
  data: () => ({
    question: TestQuestionService.getDefaultItem()
  })
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/test/Add.vue